import { useEffect } from 'react'
import { useIntl } from 'react-intl'

import { OfferRecreatedContent } from 'Modules/purchase/components/OfferRecreatedContent/OfferRecreatedContent'
import { PurchaseLayout } from 'Modules/purchase/layouts/PurchaseLayout/PurchaseLayout'

import { setRouteTitle } from 'Portal/src/router/Router.utils'

export const OfferRecreated = () => {
  const intl = useIntl()

  useEffect(() => {
    setRouteTitle(
      intl.formatMessage({
        id: 'OfferRecreatedContent_heading',
      }),
    )
  }, [intl])

  return (
    <PurchaseLayout>
      <OfferRecreatedContent />
    </PurchaseLayout>
  )
}
